import React, { useEffect} from 'react'
import { seeContactsRequests, acceptContactRequest,
cancelContactRequest } from '../../actions/contactsActions'
import { connect } from 'react-redux';
import inMemoryJWT from '../../auth/inMemoryJwt';

const ContactRequest = ({ seeContactsRequests, userContactRequests, cancelContactRequest, acceptContactRequest, isLoading }) => {
      
    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeContactsRequests()
        })
        
    },[])
    
   if(isLoading){
       return <div>Cargando...</div>
   }   
   else
    {return  <div>
    {Object.values(userContactRequests).map((user, index) => (

        <li key={index}>{user.name && user.name.toUpperCase()}
            <button onClick={()=>{acceptContactRequest(user._id)}}>Aceptar</button>
            <button onClick={()=>{cancelContactRequest(user._id)}}>Cancelar</button>
        </li>
    ))}
    </div>}
}
const mapStateToProps = (state) => {
    return {
        userContactRequests: state.contacts.userContactRequests,
        isLoading: state.contacts.isLoadingContactRequestList
    }
}

export default connect(mapStateToProps, { seeContactsRequests, acceptContactRequest, cancelContactRequest})(ContactRequest)
